"use client";

import { regionsAndCountries } from "@/lib/utils";
import categories from "@/data/categories.json";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function JobSearch() {
  const [inputValue, setInputValue] = useState<string>("");
  const [inputLocation, setInputLocation] = useState<string>("");
  const [inputCategory, setInputCategory] = useState<string>("");
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();
  const query = searchParams.get("query");
  const location = searchParams.get("location");
  const category = searchParams.get("category");

  useEffect(() => {
    if (query) {
      setInputValue(decodeURIComponent(query));
    }
    if (location) {
      setInputLocation(decodeURIComponent(location));
    }
    if (category) {
      setInputCategory(decodeURIComponent(category));
    }
  }, [query, category, location]);

  console.log({
    query,
    location,
    category,
    inputValue,
    inputLocation,
    inputCategory,
  });

  const handleSearch = async (term: string) => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    if (term) {
      params.set("query", encodeURIComponent(term));
    } else {
      params.delete("query");
    }
    await replace(`${pathname}?${params.toString()}`);
  };

  const onLocationChange = (e: any) => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    if (e.target.value) {
      params.set("location", e.target.value);
    } else {
      params.delete("location");
    }
    replace(`${pathname}?${params.toString()}`);
  };

  const onCategoryChange = (e: any) => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    if (e.target.value) {
      params.set("category", e.target.value);
    } else {
      params.delete("category");
    }
    replace(`${pathname}?${params.toString()}`);
  };

  return (
    <>
      <div className="mx-auto mt-5 hidden w-full max-w-4xl sm:block">
        <div className="join w-full">
          <div className="w-full">
            <div className="w-full">
              <input
                className="input input-bordered join-item w-full"
                placeholder="Search by skills, locations, categories ..."
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  handleSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <select
            className="select select-bordered join-item min-w-[200px]"
            value={inputLocation!}
            onChange={onLocationChange}
          >
            <option selected value="">
              Location
            </option>
            {regionsAndCountries.map((region) => (
              <option value={region.value} disabled={region.disable}>
                {region.label}
              </option>
            ))}
          </select>
          <select
            className="select select-bordered join-item min-w-[200px]"
            value={inputCategory!}
            onChange={onCategoryChange}
          >
            <option selected value="">
              Category
            </option>
            {categories.map((category) => (
              <option value={category.value}>{category.label}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="mx-auto mt-5 block w-full max-w-4xl sm:hidden">
        <div className="flex flex-col gap-3 sm:flex-row">
          <div className="w-full">
            <input
              className="input input-bordered w-full"
              placeholder="Search by skills, locations, categories ..."
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                handleSearch(e.target.value);
              }}
            />
          </div>
          <select
            className="select select-bordered w-full sm:min-w-[200px]"
            value={inputLocation!}
            onChange={onLocationChange}
          >
            <option selected value="">
              Location
            </option>
            {regionsAndCountries.map((region) => (
              <option value={region.value} disabled={region.disable}>
                {region.label}
              </option>
            ))}
          </select>
          <select
            className="select select-bordered w-full sm:min-w-[200px]"
            value={inputCategory!}
            onChange={onCategoryChange}
          >
            <option selected value="">
              Category
            </option>
            {categories.map((category) => (
              <option value={category.value}>{category.label}</option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
